import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse,
  faMagnifyingGlass,
  faUsers,
  faGear,
  faWineGlass,
  faComments,
  faMoon,
  faBook,
  faPalette,
  faUtensils,
  faMask,
  faBookOpen,
  faStar,
  faFire,
  faXmark,
  faHand,
  faCirclePause,
  faVolumeHigh,
  faHeart,
  faCalendar,
  faHandshake,
  faCheck,
  faSearch,
  faSeedling,
  faCakeCandles,
} from '@fortawesome/free-solid-svg-icons';

const iconMap = {
  '🏡': faHouse,
  '🔍': faMagnifyingGlass,
  '👥': faUsers,
  '⚙️': faGear,
  '🍷': faWineGlass,
  '💬': faComments,
  '🌙': faMoon,
  '📚': faBook,
  '🎨': faPalette,
  '🥘': faUtensils,
  '🍽️': faUtensils,
  '🎭': faMask,
  '📖': faBookOpen,
  '✨': faStar,
  '🕯️': faFire,
  '❌': faXmark,
  '👋': faHand,
  '⏸️': faCirclePause,
  '🔊': faVolumeHigh,
  '❤️': faHeart,
  '🎉': faStar,
  '🗓️': faCalendar,
  '🤝': faHandshake,
  '✓': faCheck,
  'search': faSearch,
  '🌱': faSeedling,
  '🎂': faCakeCandles,
  '⭐': faStar,
};

export default function Icon({ name, className = '', size = '1x' }) {
  const icon = iconMap[name];
  if (!icon) {
    // If it's an emoji, return it directly instead of warning
    if (name && /[\u{1F300}-\u{1F9FF}]/u.test(name)) {
      return <span className={className}>{name}</span>;
    }
    // Only warn for non-emoji missing icons (likely a bug)
    if (process.env.NODE_ENV === 'development') {
      console.warn(`Icon not found for: ${name}`);
    }
    return null;
  }
  return <FontAwesomeIcon icon={icon} className={className} size={size} />;
}

